import axios from 'axios';

export const createClient = (apiHost, authToken, withCredentials = false) => {
  const client = axios.create({
    baseURL: apiHost,
    timeout: 45000,
    withCredentials,
  });

  if (authToken) {
    client.defaults.headers.common.Authorization = `Bearer ${authToken}`;
  }

  client.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      if (!error.response) return Promise.reject(error);

      const { status } = error.response;
      if ((status === 401 || status === 403) && window.location.pathname !== `/login`) {
        window.location = `${window.location.origin}/logout?bounceUrl=${window.location.pathname}`;
      }

      return Promise.reject(error);
    }
  );

  return client;
};

export default createClient(
  process.env.REACT_APP_GLOBAL_API_URL,
  localStorage.getItem('global-opportunities-jwt'),
  process.env.REACT_APP_GLOBAL_API_WITH_CREDENTIALS
);
